import cn from "classnames";
import Select from "components/shared/select";
import { catalogFlags, catalogFlagsEnum, entityTypes, entityTypesEnum } from "helpers/enums";
import { flagVal } from "helpers/system";
import React, { useState } from "react";
import { applyOrganizationEntityOption, delCatalog } from "sources/catalogs";

const isApprovedByRootFlagValue = flagVal(catalogFlags, catalogFlagsEnum.IsApprovedByRoot);

const OptionCheckbox = ({ intFlags, value, onChange }) => {
    const checked = (intFlags & value) === value;
    const setValue = () => {
        onChange(checked ? intFlags - value : intFlags + value);
    };
    return <span className={cn("checkbox d-inline-block", { "checkbox--checked": checked })} onClick={setValue} />;
};

const OrganizationCatalogItem = (props) => {
    const { id, displayName, organizationId, entityOptions } = props;

    const [entityType, setEntityType] = useState(props.entityType);
    const [intFlags, setIntFlags] = useState(props.intFlags);
    const [isLoading, setLoading] = useState(false);

    const selectProps = {
        inputProps: { name: "entityType" },
        options: entityTypes.filter((item) =>
            [entityTypesEnum.Cargo, entityTypesEnum.TruckingBid, entityTypesEnum.BidPoint].includes(item.value),
        ),
        value: entityType,
        onChange: ({ value }) => setEntityType(value),
    };

    const deleteCatalog = () => {
        if (isLoading) {
            return null;
        }
        setLoading(true);
        const { mergeParams, getItem } = props;
        delCatalog({ id }).then((res) => {
            if (res) {
                mergeParams();
                getItem();
            }
            setLoading(false);
        });
    };

    const saveCatalog = () => {
        if (!entityType || isLoading) {
            return null;
        }
        setLoading(true);
        const { mergeParams, getItem } = props;
        const nextIntFlags = intFlags + isApprovedByRootFlagValue;
        let data;
        if ((intFlags & isApprovedByRootFlagValue) !== isApprovedByRootFlagValue) {
            setIntFlags(nextIntFlags);
            data = {
                entityType,
                displayName,
                organizationId,
                flags: nextIntFlags,
                referencedCatalogId: id,
            };
        } else {
            const entityOptionId = (entityOptions[0] && entityOptions[0].id) || null;
            data = {
                entityType,
                displayName,
                organizationId,
                flags: intFlags,
                referencedCatalogId: id,
                id: entityOptionId,
            };
        }
        applyOrganizationEntityOption(data).then((res) => {
            if (res) {
                mergeParams();
                getItem();
            }
            setLoading(false);
        });
    };
    return (
        <tr>
            <td>{id}</td>
            <td>{displayName}</td>
            <td>
                <Select {...selectProps} />
            </td>
            <td>
                <OptionCheckbox
                    value={flagVal(catalogFlags, catalogFlagsEnum.ShowInMobileApp)}
                    intFlags={intFlags}
                    onChange={setIntFlags}
                />
            </td>
            <td>
                <OptionCheckbox
                    value={flagVal(catalogFlags, catalogFlagsEnum.ShowInEmptyMileageBids)}
                    intFlags={intFlags}
                    onChange={setIntFlags}
                />
            </td>
            <td>
                <div
                    className={cn("inline-btn inline-btn--without-icon", {
                        "inline-btn--disabled": isLoading || !entityType,
                    })}
                    onClick={saveCatalog}
                >
                    {(intFlags & isApprovedByRootFlagValue) !== isApprovedByRootFlagValue ? "Одобрить" : "Сохранить"}
                </div>
                <div
                    className={cn("inline-btn inline-btn--delete", { "inline-btn--disabled": isLoading })}
                    onClick={deleteCatalog}
                >
                    Удалить
                </div>
            </td>
        </tr>
    );
};

export default OrganizationCatalogItem;
